<script>
  import { createEventDispatcher } from "svelte";
  import UppyDropzone from "#lib/dropzone/UppyDropzone.svelte";
  import { SUPABASE_URL as supabaseUrl } from "#src/env";
  import { api } from "#src/api";
  import { sortableList } from "@local/extensions/collections/sortable-list.js";

  export let group;
  export let documents;

  const dispatch = createEventDispatcher();

  async function addDocument(e) {
    const { results } = e.detail;
    const imageTypes = ["image/jpeg", "image/png", "image/gif"];

    let newDocId = null;
    if (results.length) {
      const filenames = results.map(async (r) => {
        await api
          .schema("storage")
          .from("objects")
          .update({ user_metadata: { name: r.meta.name } })
          .eq("name", r.meta.objectName)
          .eq("bucket_id", "documents");
      });

      const docid = crypto.randomUUID();

      const ready = results.every((f) => imageTypes.includes(f.meta.type));
      const t = results[0];
      const thumbnail = imageTypes.includes(t.meta.type)
        ? {
            path: t.meta.objectName,
            bucket: "documents",
            name: t.meta.name,
            type: "image",
          }
        : {
            objectName: t.meta.objectName,
            path: `${t.meta.uuid}/doc.0.tiff`,
            type: "iiif",
            bucket: "drawings",
            name: t.meta.name,
          };

      const pages = [];

      results.forEach((r) => {
        const pending = imageTypes.includes(r.meta.type) ? false : true;
        pages.push({
          id: crypto.randomUUID(),
          name: r.meta.objectName,
          label: null,
          section: null,
          hidden: false,
          page: 0,
          pending,
          scale: null,
        });
      });

      const doc = {
        id: docid,
        group_id: $group.id,
        index: documents.length,
        name: t.meta.name,
        ready,
        data: {
          pages: sortableList(pages),
          thumbnail,
        },
        type: "imported",
      };

      await group.addDocument(doc);
      await Promise.all(filenames);
      newDocId = docid;
    }

    dispatch("done-uploading", { id: newDocId });
  }
</script>

<div class="text-center text-sm font-bold">Upload New Document</div>
<div class="text-center text-xs">
  Large PDFs may take several minutes to process.<br />
  For faster results, remove unneeded pages before uploading.
</div>
<UppyDropzone
  uploadUrl={`${supabaseUrl}/storage/v1/upload/resumable`}
  bucket="documents"
  accept="application/pdf,image/jpeg,image/gif,image/png"
  height={350}
  on:complete={addDocument} />
